<template>
  <div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="details-layout p-1">
      <div class="flex w-full gap-3">
        <!-- Contact Information Section -->
        <div
          class="shadow-md p-2"
          :class="
            clientDetail &&
            clientDetail.billingInfo &&
            clientDetail.billingInfo.type === 'Postpaid'
              ? 'w-4.5/12'
              : 'w-1/2'
          "
        >
          <div class="header">
            <div class="details-header flex justify-between items-center">
              <div>
                {{ $t("customers.label.contact_information") }}
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-edit-2"
                size="small"
                title="Edit contact information"
                @click="editEntity()"
                class="rounded-full"
              ></vs-button>
            </div>
          </div>
          <div class="p-2">
            <div class="grid grid-cols-2 gap-1">
              <h6 class="font-semibold">
                {{ $t("customers.label.customer_name") }}:
              </h6>
              <span class="font-bold"
                >{{ clientDetail.personalInfo.firstName }}
                {{ clientDetail.personalInfo.middleName }}
                {{ clientDetail.personalInfo.lastName }}</span
              >
              <h6 class="font-semibold">
                {{ $t("customers.label.parent_child") }}:
              </h6>
              <span>{{ clientDetail.accountInfo.parentInfo }}</span>
              <h6 class="font-semibold">
                {{ $t("customers.label.preferred_language") }}:
              </h6>
              <span>{{ $t("customers.label.English") }}</span>
              <h6 class="font-semibold">{{ $t("customers.label.email") }}:</h6>
              <span class="wrap-email">{{
                clientDetail.personalInfo.email
              }}</span>
              <h6 class="font-semibold">{{ $t("customers.label.phone") }}:</h6>
              <span
                ><a
                  @click="callCustomer(clientDetail.personalInfo.mobileNumber)"
                  v-if="clientDetail.personalInfo.mobileNumber"
                  style="cursor: pointer"
                  >{{ clientDetail.personalInfo.mobileNumber }}</a
                ></span
              >
            </div>
          </div>
        </div>

        <!-- Address Information Section -->
        <div
          class="shadow-md p-2"
          :class="
            clientDetail &&
            clientDetail.billingInfo &&
            clientDetail.billingInfo.type === 'Postpaid'
              ? 'w-4/12'
              : 'w-1/2'
          "
        >
          <div class="header">
            <div class="details-header flex justify-between items-center">
              <div>
                {{ $t("customers.label.address_information") }}
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-edit-2"
                size="small"
                title="Edit address information"
                @click="addressEntity()"
                class="rounded-full"
              ></vs-button>
            </div>
          </div>
          <div
            class="p-2 card-content"
            v-for="(item, k) in clientDetail.addresses"
            :key="k"
          >
            <div class="grid grid-cols-2 gap-2" v-if="item.type == 'PRIMARY'">
              <h6 class="font-semibold">{{ $t("customers.label.street") }}:</h6>
              <span>{{ item.addressNo }}{{ item.street || "-" }}</span>
              <h6 class="font-semibold">
                {{ $t("customers.label.postal_code") }}:
              </h6>
              <span>{{ item.zip || "-" }} </span>
              <h6 class="font-semibold">{{ $t("customers.label.city") }}:</h6>
              <span>{{ item.city || "-" }} </span>
              <h6 class="font-semibold">
                {{ $t("customers.label.country") }}:
              </h6>
              <span>{{ item.country || "-" }} </span>
            </div>
          </div>
        </div>

        <!-- Billing Information Section -->
        <div
          class="shadow-md p-2 w-4/12"
          v-if="
            clientDetail &&
            clientDetail.billingInfo &&
            clientDetail.billingInfo.type === 'Postpaid'
          "
        >
          <div class="header">
            <div class="details-header">
              <div class="mb-3">
                {{
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === "Postpaid"
                    ? $t("customers.label.billing_information")
                    : $t("customers.label.balance_information")
                }}
              </div>
            </div>
          </div>
          <div class="p-2">
            <div
              class="grid grid-cols-2 gap-2"
              v-if="
                clientDetail &&
                clientDetail.billingInfo &&
                clientDetail.billingInfo.type === 'Postpaid'
              "
            >
              <h6 class="font-semibold">
                {{ $t("customers.label.outstanding_due") }}
                <span style="color: green"
                  >({{
                    clientDetail &&
                    clientDetail.billingInfo &&
                    clientDetail.billingInfo.currencyCode
                  }}) </span
                >:
              </h6>
              <span :style="{ color: balanceClass }">
                {{
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.dueAmount.toFixed(2)
                }}
                <span
                  class="pay-link"
                  v-if="
                    clientDetail.billingInfo &&
                    clientDetail.billingInfo.dueAmount > 0
                  "
                  @click="navigateToPayment"
                  >{{ $t("customers.label.paynow") }}</span
                ></span
              >
              <h6 class="font-semibold">
                {{ $t("customers.label.unbilled_amount") }}
                <span style="color: green"
                  >({{ clientDetail.billingInfo.currencyCode }})</span
                >:
              </h6>
              <span :style="{ color: balanceClass }">
                {{
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.unbilledAmount.toFixed(2)
                }}</span
              >
              <h6 class="font-semibold">
                {{ $t("customers.label.due_date") }}:
              </h6>
              <span>{{
                clientDetail.billingInfo.dueDate !== "NA"
                  ? getDate(clientDetail.billingInfo.dueDate)
                  : clientDetail.billingInfo.dueDate
              }}</span>

              <!-- <h6 class="font-semibold">
            {{ $t("customers.label.next_bill_day") }}:
          </h6>
          <span>{{
            clientDetail.nextBillDate
          ? getDate(clientDetail.nextBillDate)
          : ""
          }}</span> -->
              <!-- <h6 class="font-semibold my-2">{{ $t("customers.label.spend_limit") }}:</h6> 
           <span class="flex items-center gap-3"
            >N/A
            <feather-icon
          title="Edit"
          icon="EditIcon"
          svgClasses="w-4 h-4 stroke-current text-primary"
          @click="() => {}"
          class="icon_row cursor-pointer"
            />
          </span> -->
              <h6 class="font-semibold">
                {{ $t("customers.label.billing_cycle") }}:
              </h6>
              <span class="flex items-center gap-3">{{
                clientDetail.billingInfo &&
                clientDetail.billingInfo.billCycleName
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-2" v-else>
              <h6 class="font-semibold">
                {{ $t("customers.label.topup_balance") }}:
              </h6>
              <span>{{ getBalance }}</span>
              <!-- <h6 class="font-semibold">
            {{ $t("customers.label.next_renewal_date") }}:
          </h6>
          <span>N/A</span>
          <h6 class="font-semibold">
            {{ $t("customers.label.allowance") }}:
          </h6>
          <span>N/A</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.edit_customer')"
        :active.sync="editContactpopup"
        class="popup-close"
        @update:active="onPopupClose"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full ml-2">
              <div class="vx-col sm:w-1/2 w-full">
                <upload-picture
                  @image-selected="handleImageSelected"
                  @remove-image="profilePicData = null"
                  :clientImage="profilePicData"
                />
              </div>
              <div class="vx-col flex items-center sm:w-1/2 w-full">
                <div class="dropdown-with-label w-full">
                  <small class="date-label"
                    >{{ $t("customers.label.business_entity")
                    }}<span class="required"> *</span></small
                  >
                  <vue-simple-suggest
                    v-model="loc"
                    :list="locList"
                    @input="testMethod2()"
                    class="w-full font-normal"
                    :filter-by-query="true"
                    disabled
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc(suggestion.id)"
                        >{{ suggestion.externalId }} --
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{
                    $t("customers.label.title")
                  }}</small>
                  <v-select
                    label="text"
                    :options="titleOptions"
                    v-model="editCustomer.title"
                    :reduce="(text) => text.text"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.customer_category")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.customer_category')"
                    :key="resetKey"
                  >
                    <v-select
                      label="categoryType"
                      :options="getCustomerTemplate.clientCategoryDatas"
                      :reduce="(categoryType) => categoryType.id"
                      v-model="editCustomer.clientCategory"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.first_name')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.first_name')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="editCustomer.firstname"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.middle_name')"
                  class="w-full font-semibold"
                  v-model="editCustomer.middlename"
                  icon-no-border
                />
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="last name"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.last_name')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="editCustomer.lastname"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.phone')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.phone')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="editCustomer.phone"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <ValidationProvider
                  rules="digits:9"
                  v-slot="{ errors }"
                  :name="$t('customers.label.caf_id')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.caf_id')"
                    class="w-full mb-2 starlabel font-semibold"
                    v-model="editCustomer.externalId"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  :name="$t('customers.label.email')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.email')"
                    v-model="editCustomer.email"
                    class="w-full mb-2 starlabel font-semibold"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.landline_number')"
                  v-model="editCustomer.homePhoneNumber"
                  class="w-full font-semibold"
                  icon-no-border
                />
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.user_name')"
                  v-model="editCustomer.userName"
                  class="w-full font-semibold"
                  icon-no-border
                  disabled
                />
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{
                    $t("customers.label.id_proof")
                  }}</small>
                  <v-select
                    label="type"
                    :options="getCustomerTemplate.idProofs"
                    :reduce="(obj) => obj.id"
                    v-model="editCustomer.idKey"
                    :placeholder="$t('customers.label.SelectIdProof')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  />
                </div>
              </div>
              <div class="vx-col mb-2 sm:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.id_proof_value')"
                  class="w-full font-semibold"
                  v-model="editCustomer.idValue"
                  icon-no-border
                />
              </div>
            </div>

            <div class="center mb-2">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="editCustomerFunc()"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
      <vs-popup
        :title="$t('customers.label.edit_address')"
        :active.sync="editAddressPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 ml-2">
            <div class="vx-col mb-2 sm:w-1/2 md:w-1/2 lg:w-1/2">
              <small class="font-semibold">{{
                $t("customers.label.PrimaryAddress")
              }}</small>
              <vs-input
                :label="$t('customers.label.building')"
                class="w-full font-semibold mb-2 starlabel"
                v-model="addressJson[0].addressNo"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.street')"
                v-model="addressJson[0].street"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.city")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  label="text"
                  :options="addressByCustomer.cityData"
                  v-model="addressJson[0].city"
                  @input="primaryCityTemplate()"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
              <vs-input
                :label="$t('customers.label.district')"
                v-model="addressJson[0].district"
                class="w-full font-semibold mb-2 starlabel"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.state')"
                v-model="addressJson[0].state"
                class="w-full font-semibold mb-2 starlabel"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.country')"
                v-model="addressJson[0].country"
                class="w-full font-semibold mb-2 starlabel"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.zipcode')"
                v-model="addressJson[0].zip"
                class="w-full mb-2 starlabel font-semibold"
                icon-no-border
              />
            </div>
            <div class="vx-col mb-2 sm:w-1/2 md:w-1/2 lg:w-1/2">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 lg:w-1/2">
                  <small class="font-semibold">{{
                    $t("customers.label.BillingAddress")
                  }}</small>
                </div>
                <div class="vx-col md:w-1/2 lg:w-1/2">
                  <vs-checkbox v-model="sameBillingAddress"
                    ><small class="font-semibold">{{
                      $t("customers.label.same_as_primary")
                    }}</small></vs-checkbox
                  >
                </div>
              </div>
              <vs-input
                :label="$t('customers.label.building')"
                v-model="addressJson[1].addressNo"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.street')"
                v-model="addressJson[1].street"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("customers.label.city")
                }}</small>
                <v-select
                  label="text"
                  v-model="addressJson[1].city"
                  @input="billingCityTemplate"
                  :options="addressByCustomer.cityData"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
              <vs-input
                :label="$t('customers.label.district')"
                v-model="addressJson[1].district"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.state')"
                v-model="addressJson[1].state"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.country')"
                v-model="addressJson[1].country"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
              <vs-input
                :label="$t('customers.label.zipcode')"
                v-model="addressJson[1].zip"
                class="w-full font-semibold mb-2"
                icon-no-border
              />
            </div>
          </div>

          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                @click="editAddressFunc()"
                class="footerButton-next"
                style="top: 0px"
                :disabled="isSubmitDisabled"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.non_currency_details')"
        :active.sync="viewDetailsPopup"
        class="popup-close details-popup"
      >
        <div class="w-full">
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("customers.label.name") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.balance") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.valid_from") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.valid_to") }}</b>
                </td>
              </tr>
              <tr
                v-for="(detail, index) in clientDetail.clientCurrencyDatas"
                :key="index"
              >
                <td>{{ detail.name }}</td>
                <td>{{ detail.balanceAmount }} {{ detail.code }}</td>
                <td>{{ getDate(detail.validFrom) }}</td>
                <td>{{ getDate(detail.validTo) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import UploadPicture from "@/components/UploadPicture.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import { setHeader, removeHeader } from "@/http";

export default {
  data() {
    return {
      imageData: {},
      submitEdit: false,
      profilePicData: "",
      editContactpopup: false,
      editAddressPopup: false,
      viewDetailsPopup: false,
      warningPopup: false,
      sameBillingAddress: false,
      resetKey: 0,
      warningText: "",
      errorMessage: "",
      loc: "",
      titleOptions: [
        { text: "Mr.", value: "mr" },
        { text: "Mrs.", value: "mrs" },
        { text: "Ms.", value: "ms" },
        { text: "Miss", value: "miss" },
      ],
      editCustomer: {
        accountNo: "",
        activationDate: "",
        active: true,
        city: "",
        clientCategory: "",
        country: "",
        dateFormat: "yyyy-MM-dd HH:mm:ss",
        district: "",
        email: "",
        externalId: "",
        firstname: "",
        homePhoneNumber: "",
        idKey: "",
        idValue: "",
        lastname: "",
        locale: "en",
        middlename: "",
        officeId: "",
        password: "",
        phone: "",
        state: "",
        title: "",
        userName: "",
      },
      addressJson: [
        {
          addressNo: "",
          addressType: "PRIMARY",
          city: "",
          clientId: "",
          country: "",
          district: "",
          id: "",
          state: "",
          street: "",
          zip: "",
        },
        {
          addressNo: "",
          addressType: "BILLING",
          city: "",
          clientId: "",
          country: "",
          district: "",
          id: "",
          state: "",
          street: "",
          zip: "",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      allowances: (state) => state.customerOrder.allowanceList,
      profilePic: (state) => state.customer.profilePic,
      clientDetail: (state) => {
        const storedClientDetail = JSON.parse(
          localStorage.getItem("clientDetail")
        );
        return storedClientDetail || state.customer.clientDetailData;
      },
      addressByCustomer: (state) => state.customer.addressByCustomer,
      formattedDate: (state) => state.settings.selectedDateFormat,
      locList: (state) => state.entity.locationList,
    }),
    getCustomerTemplate() {
      return this.$store.getters["customer/getClientsTemplate"];
    },
    getBalance() {
      if (!this.allowances.balances) return 0;
      for (const temp of this.allowances.balances) {
        if (temp.bucketName == "Prepaid Core") return temp.availableBalance;
      }
      return 0;
    },
    balanceClass() {
      const balance = Number(this.clientDetail.financialInfo.balanceAmount);
      if (balance < 0) {
        return "red";
      } else if (balance > 0) {
        return "green";
      }
      return "";
    },
    isSubmitDisabled() {
      if (
        this.addressJson[0].addressNo &&
        this.addressJson[0].city &&
        this.addressJson[0].district &&
        this.addressJson[0].state &&
        this.addressJson[0].country &&
        this.addressJson[0].zip
      ) {
        return false;
      } else return true;
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    UploadPicture,
  },
  methods: {
    async callCustomer(phone) {
      try {
        const agent = JSON.parse(sessionStorage.getItem("ngb:user"));
        const payload = {
          callerId: phone,
          userId: agent.userId || 8,
        };
        await this.$store.dispatch("customer/callCustomerAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong",
          type: "error",
        });
      }
    },
    navigateToPayment() {
      this.$router.push(
        `/customers/customer_payment?customerId=${
          this.$route.params.id
        }&email=${this.clientDetail.personalInfo.email}&amount=${
          this.clientDetail.billingInfo.dueAmount
        }&currency=${this.clientDetail.billingInfo.currencyCode || "EUR"}`
      );
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async handleImageSelected(fileData) {
      this.imageData = fileData || {};
      try {
        let formData = new FormData();
        formData.append("clientId", this.clientDetail.customerId);
        formData.append("file", this.imageData);
        setHeader("Content-Type", "multipart/form-data");
        let payload = {
          clientId: this.clientDetail.customerId,
          formData: formData,
        };
        await this.$store.dispatch("customer/updateProfilePicture", payload);
        removeHeader("Content-Type");
        this.$toasted.success("Image Updated", {
          duration: 2000,
        });
        this.imageData = {};
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editEntity() {
      await this.$store.dispatch("customer/setClientTemplate");
      this.loc = this.clientDetail.accountInfo.office.name;
      const category = this.getCustomerTemplate.clientCategoryDatas.find(
        (e) => e.categoryType === this.clientDetail.clientCategory
      );
      this.editCustomer = {
        accountNo: this.clientDetail.accountNumber,
        activationDate: this.getDate(this.clientDetail.activationDate),
        active: this.clientDetail.status,
        city: this.clientDetail.addresses[0].city,
        clientCategory: category.id,
        country: this.clientDetail.addresses[0].country,
        dateFormat: "yyyy-MM-dd HH:mm:ss",
        district: this.clientDetail.addresses[0].district,
        email: this.clientDetail.personalInfo.email,
        externalId: this.clientDetail.externalId,
        firstname: this.clientDetail.personalInfo.firstName,
        homePhoneNumber: this.clientDetail.personalInfo.homePhoneNumber,
        idKey: "",
        idValue: this.clientDetail.personalInfo.idValue,
        lastname: this.clientDetail.personalInfo.lastName,
        locale: "en",
        middlename: this.clientDetail.personalInfo.middleName,
        officeId: this.clientDetail.accountInfo.office.id,
        password: this.clientDetail.clientPassword,
        phone: this.clientDetail.personalInfo.mobileNumber,
        state: this.clientDetail.addresses[0].state,
        title: this.clientDetail.personalInfo.title,
        userName: this.clientDetail.userName,
      };
      const idProofs = this.getCustomerTemplate.idProofs;
      const matchedIdProof = idProofs.find(
        (proof) => proof.value === this.clientDetail.personalInfo.idType
      );
      if (matchedIdProof) {
        this.editCustomer.idKey = matchedIdProof.id;
      }
      this.getProfilePic();
      this.editContactpopup = true;
    },
    async getProfilePic() {
      try {
        await this.$store.dispatch(
          "customer/getClientProfilePic",
          this.$route.params.id
        );
        this.profilePicData = this.profilePic;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async testMethod2() {
      let temp = this.loc;
      this.$store.dispatch("entity/entityGetLocationAction", this.loc);
      if (temp.includes("{")) {
        temp = JSON.parse(temp);
        if (typeof temp === "object") {
          this.loc = temp.externalId + "--" + temp.name;
          this.editCustomer.officeId = temp.id;
          this.activation.loc = temp.id;
          this.clientData[0].officeId = temp.id;
        }
      }
    },
    async primaryCityTemplate() {
      try {
        await this.$store.dispatch(
          "entity/setCityTemplate",
          this.addressJson[0].city
        );

        this.$set(
          this.addressJson[0],
          "district",
          this.cityTemplateData.district
        );
        this.$set(this.addressJson[0], "state", this.cityTemplateData.state);
        this.$set(
          this.addressJson[0],
          "country",
          this.cityTemplateData.country
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addressEntity() {
      await this.$store.dispatch(
        "customer/getCustomerAddress",
        this.$route.params.id
      );
      this.addressJson = this.addressByCustomer.datas;

      this.editAddressPopup = true;
    },
    async billingCityTemplate() {
      try {
        await this.$store.dispatch(
          "entity/setCityTemplate",
          this.addressJson[1].city
        );

        this.$set(
          this.addressJson[1],
          "district",
          this.cityTemplateData.district
        );
        this.$set(this.addressJson[1], "state", this.cityTemplateData.state);
        this.$set(
          this.addressJson[1],
          "country",
          this.cityTemplateData.country
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    onPopupClose(isActive) {
      if (!isActive) {
        this.getProfilePic();
      }
    },
    async editCustomerFunc() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      this.submitEdit = true;
      try {
        const payload = {
          id: this.$route.params.id,
          data: this.editCustomer,
        };
        payload.data.activationDate = moment(
          payload.data.activationDate
        ).format("YYYY-MM-DD HH:mm:ss");
        await this.$store.dispatch("customer/editCustomerInfo", payload);
        this.editContactpopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Update Successful!",
          type: "success",
        });
        this.submitEdit = false;
        this.getClient();
        this.getProfilePic();
      } catch (error) {
        this.editContactpopup = false;
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async editAddressFunc() {
      try {
        const payload = {
          addressJson: this.addressJson,
        };
        await this.$store.dispatch("customer/editCustomerAddress", {
          id: this.$route.params.id,
          data: payload,
        });
        this.editAddressPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Update Successful!",
          type: "success",
        });
        this.getClient();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getClient() {
      try {
        const data = await this.$store.dispatch(
          "customer/setClientDetailData",
          this.$route.params.id
        );
        this.makeStatement.message = data.data.invoiceType;
        localStorage.setItem("clientDetail", JSON.stringify(data.data));
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  watch: {
    sameBillingAddress(val) {
      if (val) {
        this.addressJson[1] = { ...this.addressJson[0] };
        this.addressJson[1].addressType = "BILLING";
      }
    },
  },
  mounted() {
    if (!this.clientDetail) {
      this.getClient();
    }
  },
};
</script>
<style>
.wrap-email {
  display: inline-block;
  max-width: 100%;
  overflow-wrap: break-word;
}

.pay-link {
  color: #1e90ff;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;
  font-size: 14px;
  font-weight: 400;
}
</style>
